module.exports = __webpack_public_path__ + "img/enrique.2ba8bfb.png";